import types from '../types';

const initialState = {
  loading: false,
  groups: [],
  error: '',
};

const groupReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.reducerTypes.GROUP_LIST_PENDING:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.reducerTypes.GROUP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        groups: action.payload.results || [],
      };
    case types.reducerTypes.GROUP_LIST_ERROR:
      return {
        ...state,
        loading: false,
        groups: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default groupReducer;
